import React from 'react';

import './EventInfo.css';
import SpinnerMiddleware from '../SpinnerMiddleware/SpinnerMiddleware';
import { Paragraph } from '../Paragraph/Paragraph';

export const EventInfo = ({ first, second, secondSize, className = '' }) => {
  return (
    <div className={`event-info-container d-flex gap-3 ${className}`}>
      <SpinnerMiddleware targetParameter={first}>
        <span className="event-info__first">{first}</span>
      </SpinnerMiddleware>
      <SpinnerMiddleware targetParameter={second}>
        <Paragraph size={secondSize}>{second}</Paragraph>
      </SpinnerMiddleware>
    </div>
  );
};
